import { initFooterSection } from "@/modules/section-footer";
import cookiePopup from "@/modules/popup-cookie";
import { Slicker } from '@rooi/slicker/esm2015/index';
import video from "@/modules/lazyframe";
import ready from "@/scripts/helpers/dom/ready";
import Parallax from "parallax-js";
import { clickTracker } from "@/scripts/helpers/clickTracker";
// import handleScroll from "@/modules/section-header";
import { headerFunctions } from "@/modules/section-header";


const slicker = new Slicker(document.querySelector('.partners.js-slider'), {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 6000,
  autoplaySpeed: 0,
  slidesToScroll: 1,
  centerMode: false,
  variableWidth: true,
  draggable: true,
  autoplay: true,
  swipeToSlide: true,
  pauseOnHover: false,
  fade: false,
  cssEase: 'linear',
  useTransform: false
});

const cards = document.querySelectorAll('.card');

if (cards) {
  cards.forEach(card => {
    card.addEventListener('click', e => {
      if (card.hasAttribute('href')) {
        window.location.href = card.getAttribute('href');
      }
      else if (card.querySelector('.card__title-link')) {
        window.location.href = card.querySelector('.card__title-link').getAttribute('href');
      }
      else if (card.querySelector('.card__title-link')) {
        window.location.href = card.querySelector('.card__title-link').getAttribute('href');
      }
    });
  });
}

const titles = [...document.querySelectorAll(".section-title--features")]
let currentSource = "";

window.addEventListener("scroll", () => {
  let source = currentSource;
  let closest = Infinity;

  titles.forEach( title => {
    const y = title.getBoundingClientRect().y;
    const titleSource = title.dataset.src;
    if(closest >  Math.abs(y)) {
      closest = Math.abs(y);
      source = titleSource

    }
  })
  if(currentSource !== source) {
    changeVideo(source)
  }
});

function changeVideo(source) {
  const video = document.querySelector(".feature-scroll__sticky-content video");
  const videoUrl = video.getAttribute('src');
  const splitUrl = videoUrl.split('/');
  const lastPart = splitUrl[splitUrl.length - 1];
  const newVideoUrl = videoUrl.replace(lastPart, source);

  video.setAttribute("src", newVideoUrl)
  currentSource = source
}

const scenes = [...document.querySelectorAll('.parallax-wrapper')];
const initParallaxDecorations = scene => {
  const parallaxInstance = new Parallax(scene, {
    relativeInput: false,
    invertX: false,
    invertY: false,
    calibrateY: false
  });
  parallaxInstance.friction(0.2, 0.2);
};

scenes.forEach( scene => {
  initParallaxDecorations(scene); 
} )

ready( () => {
  headerFunctions();
  initFooterSection();
  video();
  clickTracker();

  setTimeout(() => {
    cookiePopup();
  }, 4000);
});
